export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_alphamonkeyclub.png",
      alt: "Nome da extensão",
    },
    title: "Alpha Monkey Club",
    text: [
      "O Alpha Monkey Club é uma empresa especializada em análise quantitativa e preditiva de dados financeiros. Como parceiros oficiais da NVIDIA, utilizamos os processadores mais avançados do mundo para treinar nossos modelos matemáticos com grande volume de dados — aplicando técnicas de processamento de grande quantidade de dados e aprendizado de máquina para prever movimentos do mercado com alta precisão. ",
      "Somos pioneiros no Brasil nessa abordagem, unindo ciência de dados, inteligência artificial e validações robustas para entregar previsões consistentes e confiáveis, baseadas em dados reais. ",
    ],
    testimonial: {
      text: "Na Alpha Monkey Club, unimos inteligência artificial, previsão de mercado e análise de grandes volumes de dados para transformar imprevisibilidade do mercado financeiro em decisões estratégicas previsíveis.",
      author: {
        name: "Luciano Sena – Fundador do Alpha Monkey Club",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "Alguns números da Alpha Monkey Club",
    subtitle: "Rigor científico, escala de dados e inteligência real",
    data: [
      {
        value: "+25",
        description: "Ativos analisados além do mini índice e mini dólar",
      },
      {
        value: "+20k",
        description: "Variáveis e indicadores de todos os ativos criados para cada IA",
      },
      {
        value: "Desde 2022",
        description: "Validação em teste cego (paper trade) com dados que IA nunca viu durante o treinamento ",
      },
      {
        value: "+10",
        description: "Anos de experiência em ciência de dados e machine learning",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Alpha Monkey Club?",
    subtitle: "Veja quais as principais vantagens dos robôs da Alpha Monkey Club.",
    data: [
      {
        title: "Previsão Inteligente ",
        description:
          "Modelos com IA analisam padrões de mercado para prever movimentos com base em dados reais, aumentando a chance de decisões assertivas.",
      },
      {
        title: "Os Alphas",
        description:
          "Um Alpha é um modelo preditivo com IA criado para superar o benchmark. Diferente de estratégias fixas, ele aprende, se adapta e busca gerar retornos acima do mercado.",
      },
      {
        title: "Análise Ampla ",
        description:
          "Nossos modelos não analisam apenas o ativo alvo. Eles consideram todos os ativos da bolsa e notícias processadas por IA para decisões mais completas e informadas.",
      },
      {
        title: "Base de Treino",
        description:
          "Utilizamos dados de 1980 até 31/12/2021 no processo de treino e teste dos Alphas. Esse período é conhecido como backtesting, comum no mercado, mas tratado aqui com rigor técnico.",
      },
      {
        title: "Base de Validação",
        description:
          "A partir de 1º de janeiro de 2022, os modelos são testados com dados desconhecidos, como em um teste cego (paper trade), validando sua eficácia em tempo real.",
      },
      {
        title: "Aprendizado Contínuo",
        description:
          "Os Alphas usam aprendizado por reforço para evoluir com o mercado. Mesmo após implantados, continuam aprendendo com novos dados e situações reais. ",
      },
    ],
  },
  cta: {
    title: "Ative seu portfólio com IA preditiva e comece a investir com inteligência real.",
    subtitle: "Iniciar Jornada",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Alpha Monkey Club",
    col1: [
      "A Alpha Monkey Club é parceira oficial da NVIDIA, líder global em computação de alto desempenho. Utilizamos os processadores mais avançados do mercado para desenvolver estratégias com base em inteligência artificial treinada com grande quantidade de dados (Big Data). ",
      "Nossos modelos seguem práticas da ciência de dados, com processos estruturados de separação entre dados de treino e validação, garantindo previsões realistas, consistentes e bem fundamentadas.",
    ],
    col2: [
      "Diferente de estratégias fixas, nossos algoritmos aprendem e se adaptam aos comportamentos do mercado, resultando em decisões mais inteligentes para quem busca performance com confiança.",
      "A tecnologia da Alpha Monkey Club une precisão estatística, validação robusta e inovação contínua — entregando ao investidor uma nova forma de operar com inteligência. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Alpha Monkey Club",
  },
  strategies: {
    title: "Portfólios Inteligentes ",
    heading: "Encontre o Alpha ideal para o seu perfil",
    subtitle:
      "Nossos portfólios são compostos por modelos preditivos de alta performance, treinados com inteligência artificial e validados em diferentes cenários de mercado. Escolha a combinação que mais se adapta aos seus objetivos e comece a operar com inteligência real. ",
  },
};
